module.exports = __webpack_public_path__ + "img/set-meal.7949b066.png";